@let loading = (adminSignals.loading | async) ?? false;
@let selectedOrgId = adminSignals.currentSelectedOrgId | async;
@let isBanker = configService.getConfig.client.support?.isBanker ?? false;
<p-button
    [label]="'admin.add_organization' | translate"
    icon="ms ms-add"
    [fluid]="true"
    [disabled]="loading"
    (onClick)="routeToNewOrganisationForm()" />
<div class="org-list__panel card">
    <header class="org-list__head">
        <h2 class="section-title org-list__title">{{ 'admin.organizations' | translate }}</h2>
        @if (isLoaded) {
            <span class="count-badge">{{ organizations.length }}</span>
        }
    </header>
    <p-iconfield>
        <p-inputicon styleClass="ms ms-search" />
        <input
            pInputText
            type="text"
            [fluid]="true"
            [placeholder]="'common.search' | translate"
            [attr.aria-label]="'common.search' | translate"
            (input)="search($any($event.target).value)" />
    </p-iconfield>
    <div class="org-list__scroll">
        <ul class="pick-list">
            @for (organization of visibleOrganizations; track organization.uid) {
                <li>
                    <ng-container
                        *ngTemplateOutlet="orgRow; context: { $implicit: organization, showSolutions: isBanker }" />
                </li>
            } @empty {
                <!-- First load: skeleton rows in place of the empty state. -->
                @if (!isLoaded) {
                    @for (i of [1, 2, 3, 4]; track i) {
                        <li class="pick-row pick-row--skeleton">
                            <p-skeleton size="2.25rem" />
                            <span class="pick-row__identity">
                                <p-skeleton width="70%" />
                            </span>
                        </li>
                    }
                } @else {
                    <li class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</li>
                }
            }
        </ul>
        @if (isLoaded && unassignedOrganizations.length > 0 && isGlobalAdmin && clientName === 'Dcarbonize') {
            <p-accordion class="org-list__unassigned">
                <p-accordion-panel [value]="0">
                    <p-accordion-header>
                        <span class="org-list__head">
                            {{ 'admin.unassigned' | translate }}
                            <span class="count-badge">{{ unassignedOrganizations.length }}</span>
                        </span>
                    </p-accordion-header>
                    <p-accordion-content>
                        <ul class="pick-list">
                            @for (organization of visibleUnassigned; track organization.uid) {
                                <li>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            orgRow;
                                            context: { $implicit: organization, showSolutions: true }
                                        " />
                                </li>
                            } @empty {
                                <li class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</li>
                            }
                        </ul>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        }
    </div>
</div>

<!-- An organisation: its initials on a square (a person's are round), its name, and for a bank
the count of solutions waiting. -->
<ng-template #orgRow let-organization let-showSolutions="showSolutions">
    <button
        type="button"
        class="pick-row"
        [class.is-active]="organization.uid === selectedOrgId"
        [attr.aria-current]="organization.uid === selectedOrgId ? 'page' : null"
        [disabled]="loading"
        (click)="routeToOrganisationForm(organization)">
        <span
            class="pick-row__avatar pick-row__avatar--square"
            aria-hidden="true"
            [style.--avatar-color]="avatarColor(organization.index)"
            >{{ organization.initials }}</span
        >
        <span class="pick-row__identity">
            <span class="pick-row__name" [pTooltip]="organization.name" tooltipPosition="top" [showDelay]="400">{{
                organization.name
            }}</span>
        </span>
        @if (showSolutions && organization.solutionCount > 0) {
            <p-badge [value]="organization.solutionCount" severity="warn" />
        }
    </button>
</ng-template>
